import { createContext, useContext } from 'react';

const AccordionContext = createContext({
    variant: "contained",
    inverse: false,
    additionalLabel: "",
    showTopDivider: false,
});
// Create a hook to access the accordion context
const useAccordionContext = () => useContext(AccordionContext);

export { AccordionContext, useAccordionContext };
